export const collapsedMobileHidden = {
    translateY: '100%',
};

export const collapsedMobileShow = {
    translateY: '0%',
};

export const collapsedMobilePulled = {
    translateY: '-10%',
};

export const collapsedTabletHidden = {
    translateX: '100%',
};

export const collapsedTabletShow = {
    translateX: '0%',
};

export const collapsedTabletPulled = {
    translateX: '-10%',
};
